export function isScrollWillDown() {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //变量windowHeight是可视区的高度
  var windowHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  //变量scrollHeight是滚动条的总高度
  var scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight;
  //滚动条到底部的条件
  if (scrollTop + windowHeight == scrollHeight) {
    //到了这个就可以进行业务逻辑加载后台数据了
    // _this.footerText = '我是有底线的';
    // console.log("快到底部了");
    return true;
  } else {
    return false;
  }
}
export function isScrollWillDown80() {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //变量windowHeight是可视区的高度
  var windowHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  //变量scrollHeight是滚动条的总高度
  var scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight;
  //滚动条到底部的条件
  if (scrollTop + windowHeight + 80 >= scrollHeight) {
    //到了这个就可以进行业务逻辑加载后台数据了
    // _this.footerText = '我是有底线的';
    // console.log("快到底部了");
    return true;
  } else {
    return false;
  }
}

export function isshowtop() {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //变量windowHeight是可视区的高度
  var windowHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
  //滚动超过当前页面
  if (scrollTop > windowHeight) {
    return true;
  } else {
    return false;
  }
}
